import { ConfirmRestore } from "@/shared/confirmRestore/ConfirmRestore";
import { InvoicesHistoryData } from "@/types";
import { Row, Table } from "@tanstack/react-table"
import { MoreHorizontal, Trash2, Undo2 } from "lucide-react"
import { useRef, useState } from "react";
import { ArchivedInvoicesTableMeta } from "./invoicesArchive";
import { CSSTransition } from "react-transition-group";
import { $transactions } from "@/stores";
import { useClickOutside } from "@/utils";
import { ConfirmDelete } from "@/shared/confirmDelete/ConfirmDelete";
interface DataTableRowActionsProps<TData> {
    row: Row<InvoicesHistoryData>
    table: Table<TData>
}

export function InvoiceArchiveTableRowActions<TData>({
    row,
    table
}: DataTableRowActionsProps<TData>) {
    const { restoreInvoice, setOpenOptionsId, openOptionsId, deleteInvoice } = table.options.meta as ArchivedInvoicesTableMeta;
    const [confirmRestore, setConfirmRestore] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);

    const areaRef = useRef(null);

    const transactionCount = $transactions.value.values.filter((item) => item.invoiceNumber === row.original.invoiceNumber).length;
    useClickOutside(areaRef, () => {
        if (row.id === openOptionsId) setOpenOptionsId(null);
    }, "row-actions__trigger-button");
    return (
        <div className="row-actions" onClick={(e) => e.stopPropagation()}>
            <div className="row-actions__container">
                <div className="row-actions__buttons-row">
                    <button className="row-actions__trigger-button" onClick={() => {
                        setOpenOptionsId(row.id);
                    }}>
                        <MoreHorizontal width={18} height={18} />
                    </button>
                    <CSSTransition in={row.id === openOptionsId}
                        timeout={200}
                        classNames="fade"
                        exit={false}
                        unmountOnExit>
                        <div className="row-actions__options" ref={areaRef}>
                            <ul className="row-actions__options-list">
                                <li className="row-actions__option row-actions__warning">
                                    <button className="row-actions__option-button" onClick={() => {
                                        setConfirmRestore(true);
                                    }} >
                                        <Undo2 width={16} height={16} />
                                        <p>Restore</p>
                                    </button>
                                </li>
                                {transactionCount === 0 && <li className="row-actions__option row-actions__warning">
                                    <button className="row-actions__option-button row-actions__warning" onClick={() => {
                                        setConfirmDelete(true);
                                        setOpenOptionsId(null);
                                    }} >
                                        <Trash2 width={16} height={16} />
                                        <p>Delete</p>
                                    </button>
                                </li>}
                            </ul>
                        </div>
                    </CSSTransition>
                </div>
            </div>
            {confirmRestore && <div className="overlay">
                <ConfirmRestore
                    type="Invoice"
                    id={row.original.invoiceNumber}
                    onClose={() => { setConfirmRestore(false); }}
                    onRestore={async () => { await restoreInvoice(row.original.invoiceNumber) }}
                />
            </div>}
            {confirmDelete && <div className="overlay">
                <ConfirmDelete
                    type="Invoice"
                    action={"Delete"}
                    id={row.original.invoiceNumber}
                    onClose={() => { setConfirmDelete(false) }}
                    onDelete={async () => {
                        await deleteInvoice(row.original.invoiceNumber);
                    }}
                />
            </div>}
        </div>
    )
}